import Vue from 'vue'

// 传统采购中英文对照
Vue.filter('purchaseStatus', value => {
    const map = {
        Created: '待收货',
        Processing: '处理中',
        Completed: '已完成'
    }
    return map[value]
})

// 传统采购英文对照状态步骤
Vue.filter('purchaseStatusToStep', value => {
    const map = {
        Created: 1,
        Processing: 2,
        Completed: 3
    }
    return map[value]
})

// 委托类型
Vue.filter('entrustType', value => {
    switch (value) {
        case 1:
            return '只租'
        case 2:
            return '只售'
        case 3:
            return '可租可售'
        case 4:
            return '代管'
        default:
            break
    }
})

// 委托采购状态
Vue.filter('indentStatus', value => {
    switch (value) {
        case 1:
            return '待收货'
        case 2:
            return '处理中'
        case 3:
            return '已完成'
        default:
            break
    }
})

// 品项tag标签的类型
Vue.filter('qualityType', value => {
    const map = {
        原装全新: 'success',
        原装九五成新: 'primary',
        原装九成新: 'primary',
        原装二手: 'warning',
        国产全新A: 'success',
        国产全新B: 'success',
        国产全新C: 'success',
        国产二手: 'warning',
        原装全新改装: 'success',
        原装九成新改装: 'primary',
        原装二手改装: 'warning',
        国产全新改装: 'success',
        国产二手改装: 'warning'
    }
    return map[value] || 'primary'
})

// 日期
Vue.filter('date', (value, format = 'YYYY-MM-DD HH:mm:ss') => {
    if (!value) return '-'
    return Vue.$moment(value).format(format)
})